var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "42px",
    viewBox: "0 0 37 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360.000000, -3751.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(339.000000, 3491.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-flag",
    transform: "translate(21.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96428571,1.96875 C3.96428571,0.877734375 3.08058036,0 1.98214286,0 C0.883705357,0 0,0.877734375 0,1.96875 L0,5.25 L0,28.7519531 L0,32.8125 L0,40.03125 C0,41.1222656 0.883705357,42 1.98214286,42 C3.08058036,42 3.96428571,41.1222656 3.96428571,40.03125 L3.96428571,31.828125 L10.5962054,30.1792969 C13.990625,29.334375 17.5832589,29.728125 20.7133929,31.2785156 C24.3638393,33.0914062 28.6006696,33.3128906 32.4162946,31.8855469 L35.2821429,30.8191406 C36.3145089,30.4335937 37,29.4574219 37,28.3582031 L37,5.42226562 C37,3.53554687 35.0013393,2.30507812 33.3,3.15 L32.5071429,3.54375 C28.6832589,5.446875 24.1821429,5.446875 20.3582589,3.54375 C17.459375,2.1 14.1310268,1.7390625 10.984375,2.51835937 L3.96428571,4.265625 L3.96428571,1.96875 Z M3.96428571,8.32617188 L11.9424107,6.34101562 C14.1723214,5.79140625 16.5261161,6.04570312 18.5825893,7.06289062 C23.1167411,9.31054687 28.3859375,9.49921875 33.0357143,7.62070312 L33.0357143,27.4558594 L31.0205357,28.2023437 C28.2372768,29.2359375 25.1401786,29.0800781 22.4808036,27.759375 C18.5,25.7824219 13.9493304,25.2902344 9.62991071,26.3566406 L3.96428571,27.7675781 L3.96428571,8.32617188 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.e735d0b86ddf055a34dedb9093c4656c.svg";
export { ForwardRef as ReactComponent };